// import HappinessBG from "../../../assets/images/HappinessBG.jpeg";

export default {
  container: {
    // display: "flex",
    marginBottom: "10px",
  },
  happinessContainer: {
    marginTop: "-32px",
    paddingTop: "24px",
    boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.05)",
    borderRadius: "8px",
    background: "#FFF",
  },
  header: {
    // fontSize: "10px",
    // color: "#000",
    // float: "right",
    // fontWeight: 600,
    // stroke: "#000",
    // strokeWidth: 1,

    color: "#333",
    // fontFeatureSettings: 'clig' off, 'liga' off,

    /* Content Title 18px */
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "20px" /* 111.111% */,
  },
  syncIcon: {
    width: "12px",
    height: "12px",
    marginBottom: "-2px",
  },
  countDiv: { paddingTop: "8px" },
  counter: {
    // width: "30px",
    // height: "45px",
    // padding: "1px 4px",
    // borderRadius: "4px",
    // margin: "2px",
    // border: "1px solid #00000E",
    // cursor: "default",
    // background:
    //   "linear-gradient(180deg, #495A94 0%, #040F38 49.99%, #28364F 50.26%, #244980 100%)",
    // color: "#FFFFFF",
    // fontSize: "28px",
    // fontWeight: 700,
    // color: "#2556A3",
    fontSize: "32px",
    fontWeight: "600",
    lineHeight: "20px",
  },

  subscriptionContainer: {
    marginTop: "10px",
    borderRadius: "8px",
    background: "#FFF",
    boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.05)",
  },

  radioButton: {
    color: "#484848",
    padding: "0.3rem 0.3rem",
    fontSize: 14,
    fontWeight: 400,
    cursor: "pointer",
  },
  activeRadio: {
    padding: "0.3rem 0.3rem",
    color: "#004E92",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
  },
};
